import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  	name: 'search'
})

export class SearchPipe implements PipeTransform {

  	// transform(value: any, args?: any): any {
   //  	return null;
  	// }

  	transform(items: any[], searchText: string): any[] {
  		if(!items) return [];
  		if(!searchText) return items;

  		searchText = searchText.toLowerCase();

  		return items.filter( item => {
  			return item.name.toLowerCase().includes(searchText);
  		});
  	}

}



// WEBPACK FOOTER //
// ./src/app/pipes/search.pipe.ts